module.exports = __webpack_public_path__ + "media/images/front/event/dummypic2-b5810a0d6ccad06919dc6fcb93654a9e.svg";